<template>
  <div class="main">
    <div style="min-height:700px;padding-top:20px;background:#fff">
      <div class="itemName">
        <el-divider>
          <div class="dividerFont">
            <span>我的收藏</span>
            <div style="width:60px;height:2px;background-color:#029AFF"></div>
          </div>
        </el-divider>
      </div>
    <el-table
      ref="multipleTable"
      stripe
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @row-click="toDatum"
    >
      <el-table-column align="center" type="selection" min-width="5%">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        label="公司名称"
        min-width="25%"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="postName"
        label="职位名称"
        min-width="25%"
      >
      </el-table-column>
      <el-table-column align="center" prop="pay" label="薪资" min-width="20%">
        <template slot-scope="scope">

          <span>{{
            getPay(scope.row.pay)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="收藏时间"
        min-width="25%"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.createTime.substring(
              0,
              scope.row.createTime.lastIndexOf('.')
            )
          }}</span>
        </template>
      </el-table-column>

       <el-table-column align="center" label="收藏操作" min-width="15%" >
          <template slot-scope="scope">
           <el-button type="warning" @click.stop="cancel(scope.row)">取消收藏</el-button>
          </template>
        </el-table-column>
    </el-table>
    </div>

    <div style="text-align: center; margin-top: 20px">
      <el-pagination
        :background="true"
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        @current-change="chengePagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {collectPage} from '@/api/myCollection/myCollection'
import { jobPostRedCollectAdd } from '@/api/position/position'
export default {
  name: '',
  data() {
    return {
      tableData: [],
      multipleSelection: '',
      id: '',
      list: [], //简历数组
      total: 1,
      jobPay: [], //薪资
      dict: []
    }
  },
  watch: {},
  props: {},
  components: {},
  created() {
    this.getCollectPage()
    this.dict = JSON.parse(localStorage.getItem('dict'))
    this.jobPay = this.dict.filter((i) => i.code == 'job_pay')[0].children
  },
  computed: {},
  mounted() {},
  methods: {
    toDatum(e) {
      console.log(e, '点击当前行')
      this.$router.push({ path: '/datum', query: { id: e.postId } })
    },
    // 查询收藏职位
    getCollectPage() {
      let obj = {
        userId: localStorage.getItem('userId'),
        type: 2,
        pageNo: 1,
        pageSize: 10
      }
      collectPage(obj).then(res => {
        console.log(res,'收藏职位')
        this.tableData = res.data.rows
        this.total = res.data.totalRows
      })
    },
    chengePagination(cur) {
      const obj = {
        userId: localStorage.getItem('userId'),
        type: 2,
        pageNo: cur,
        pageSize: 10
      }
      collectPage(obj).then(res => {
        console.log(res,'收藏职位')
        this.tableData = res.data.rows
        this.total = res.data.totalRows
      })
    },
    getPay(code) {
      return this.jobPay.filter((i) => i.code == code)[0].name
    },
    // 取消收藏
    cancel(info) {
      let obj = {
        userId: localStorage.getItem('userId'),
        type: 3,
        postId: info.postId
      }
      jobPostRedCollectAdd(obj).then(res => {
        // console.log(res,'取消收藏')
        this.getCollectPage()
        // this.tableData = res.data.rows
        // this.total = res.data.totalRows
      })
    },

    handleClick(tab, event) {
      console.log(tab, event)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    isRemind(e) {
      console.log(e)
      e.remind = !e.remind
      console.log(this.tableData)
    },
    onSubmit() {},
  },
  filters: {},
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-pagination.is-background .btn-prev {
    /*对下一页的按钮样式进行修改*/
    background: #fff;
  }
  .el-pagination.is-background .btn-next {
    /*对上一页的按钮样式进行修改*/
    background: #fff;
  }
  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff; // 进行修改未选中背景和字体
    // color: #fff;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: rgb(19, 138, 206); // 进行修改选中项背景和字体
    color: rgb(255, 255, 255);
  }
}

::v-deep .el-table .el-table__row {
  cursor: pointer;
}

.itemName {
  padding: 0 86px;
  padding-bottom: 22px;
  .dividerFont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 50px;
    span {
      font-size: 24px;
      margin-bottom: 6px;
    }
  }
}

.viewDetails {
  display: flex;
  justify-content: space-between;
  align-content: center;
  img {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}
</style>
